jQuery(function ($) {
  'use strict';

  function PasswordField(element) {
    this.element = element;
    this.container = this.element.closest('.mdc-text-field');
    this.controls = {
      passwordField: this.container.find('.mdc-text-field__input')
    };
    this.attributes = {
      eyeOpenClass: 'ial-fu_050',
      eyeClosedClass: 'ial-fu_051'
    }
    
    this.bindEvents();
  }

  PasswordField.prototype.bindEvents = function () {
    var self = this;

    this.element.on('click', function() {
      if (self.controls.passwordField.attr('type') === 'password') {
        self.controls.passwordField.attr('type', 'text');
        self.element.removeClass(self.attributes.eyeClosedClass);
        self.element.addClass(self.attributes.eyeOpenClass);
      } else {
        self.controls.passwordField.attr('type', 'password');
        self.element.removeClass(self.attributes.eyeOpenClass);
        self.element.addClass(self.attributes.eyeClosedClass);
      }

      self.controls.passwordField.focus();
    });
  }

  $(document).ready(function () {
    var passwordElements = $('.js-ipo-mdc-passwordfield');
    if (passwordElements.length > 0) 
    {
      passwordElements.each(function() {
        new PasswordField($(this));
      });      
    }
  });
});
